import React from 'react';
import {StyleSheet, View} from 'react-native';
import {colorPalette} from '../../../styles/Colors';

export default function BaseItem(props) {
  const {children, containerStyle, isSelected} = props;

  return (
    <View
      style={[
        styles.container,
        {
          borderColor: isSelected ? colorPalette.purple700 : colorPalette.grey1,
        },
        containerStyle,
      ]}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    borderWidth: 1,
    marginHorizontal: 16,
    borderRadius: 18,
  },
});
